import { Alert, Form } from 'react-bootstrap';
import FileUpload from '@nkr/components/file-upload';
import { FileDocumentType } from '@nkr/enums/document-type';
import { IFileUpload, IRecipientProfileRecords } from '@nkr/models/index';
import { RecordsTableWrapper } from '@nkr/views/donors/profile/styles';

interface IProps {
    data: IRecipientProfileRecords,
    files: IFileUpload[]
    onViewFile: (docType: FileDocumentType) => void,
    onFileUpload: (docType: FileDocumentType, file: File) => void,
    onRemoveFile: (docType: FileDocumentType) => void
}

const Content = (props: IProps) => {
    const handleVoucherDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.VoucherForm, files[0]);
    };

    const handleVoucherRemove = () => {
        props.onRemoveFile(FileDocumentType.VoucherForm);
    };

    const handleAboDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.RecipientAbo, files[0]);
    };

    const handleAboRemove = () => {
        props.onRemoveFile(FileDocumentType.RecipientAbo);
    };

    const handleDemoDropped = (files: File[]) => {
        props.onFileUpload(FileDocumentType.RecipientDemo, files[0]);
    };

    const handleDemoRemove = () => {
        props.onRemoveFile(FileDocumentType.RecipientDemo);
    };

    const getFileData = (docType: FileDocumentType) => {

        let fileData = props.files.find(x => x.docType == docType);
        if (fileData == null) return [];

        return fileData.file;
    }

    if (props.data == null)
        return null;

    return (
        <>
            <div style={{ margin: '10px' }}>
                <Form>
                    <Alert bsStyle='info' bsSize='sm'>Note, only one of each type of file may be uploaded.  If you wish to upload a new attachment, please be sure the attachment is complete before uploading it.</Alert>

                    <RecordsTableWrapper condensed striped>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Date Uploaded</th>
                                <th>View</th>
                                <th>Upload</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(props.data.isVoucher || props.data.isRemoteDirect) && (
                                <tr>
                                    <td>
                                        <label className='control-label'>Voucher Form</label>
                                    </td>
                                    <td>
                                        N/A
                                    </td>
                                    <td>
                                        {(props.data.adpFormFilePath != '' && props.data.adpFormFilePath != null) ?
                                            <a style={{ cursor: "pointer" }} onClick={() => props.onViewFile(FileDocumentType.VoucherForm)}> View </a>
                                            :
                                            <>--</>
                                        }
                                    </td>
                                    <td>
                                        <FileUpload
                                            label='Click here to select the file or drag &amp; drop the file here...'
                                            files={getFileData(FileDocumentType.VoucherForm)}
                                            singleUploadOnly={true}
                                            height='30px'
                                            onFileDropped={handleVoucherDropped}
                                            onRemoveFile={handleVoucherRemove} />
                                    </td>
                                </tr>
                            )}

                            <tr>
                                <td>
                                    <label className='control-label'>Recipient ABO Verification</label>
                                </td>
                                <td>
                                    {props.data.aboUploadDate.length > 0 ? props.data.aboUploadDate : 'N/A'}
                                </td>
                                <td>
                                    {(props.data.aboUploadPath != '' && props.data.aboUploadPath != null) ?
                                        <a style={{ cursor: "pointer" }} onClick={() => props.onViewFile(FileDocumentType.RecipientAbo)}>View</a>
                                        :
                                        <>--</>
                                    }
                                </td>
                                <td>
                                    <FileUpload
                                        label='Click here to select the file or drag &amp; drop the file here...'
                                        files={getFileData(FileDocumentType.RecipientAbo)}
                                        singleUploadOnly={true}
                                        height='30px'
                                        onFileDropped={handleAboDropped}
                                        onRemoveFile={handleAboRemove} />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <label className='control-label'>Recipient Demographics</label>
                                </td>
                                <td>
                                    {props.data.demographicsUploadDate.length > 0 ? props.data.demographicsUploadDate : 'N/A'}
                                </td>
                                <td>
                                    {(props.data.demographicsUploadPath != '' && props.data.demographicsUploadPath != null) ?
                                        <a style={{ cursor: "pointer" }} onClick={() => props.onViewFile(FileDocumentType.RecipientDemo)}>View</a>
                                        :
                                        <>--</>
                                    }
                                </td>
                                <td>
                                    <FileUpload
                                        label='Click here to select the file or drag &amp; drop the file here...'
                                        files={getFileData(FileDocumentType.RecipientDemo)}
                                        singleUploadOnly={true}
                                        height='30px'
                                        onFileDropped={handleDemoDropped}
                                        onRemoveFile={handleDemoRemove} />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <label className='control-label'>NKR High Resolution Tissue Typing</label>
                                </td>
                                <td>
                                    {props.data.histogeneticsPdfTypingUploadDate.length > 0 ? props.data.histogeneticsPdfTypingUploadDate : 'N/A'}
                                </td>
                                <td>
                                    {(props.data.histogeneticsPdfTypingFile != '' && props.data.histogeneticsPdfTypingFile != null) ?
                                        <a style={{ cursor: "pointer" }} onClick={() => props.onViewFile(FileDocumentType.RecipientHistoTyping)}>View</a>
                                        :
                                        <>--</>
                                    }
                                </td>
                                <td></td>
                            </tr>

                            <tr>
                                <td>
                                    <label className='control-label'>NKR Confirmatory ABO Typing</label>
                                </td>
                                <td>
                                    {props.data.histogeneticsPdfAboUploadDate.length > 0 ? props.data.histogeneticsPdfAboUploadDate : 'N/A'}
                                </td>
                                <td>
                                    {(props.data.histogeneticsPdfAboFile != '' && props.data.histogeneticsPdfAboFile != null) ?
                                        <a style={{ cursor: "pointer" }} onClick={() => props.onViewFile(FileDocumentType.RecipientHistoAbo)}>View</a>
                                        :
                                        <>--</>
                                    }
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </RecordsTableWrapper>
                </Form>
            </div>
        </>
    );
}

export default Content;